import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import { useSearchParams } from "react-router";
import { useMissionRole } from "hooks";
import { MISSION_ROLE_STATES } from "constants/index";
import { isTalentSimpleBrand } from "constants/brands";
import { LoginContainer } from "components/Login";
import SignupForms from "components/Signup/SignupForms";
import backgroundNormal from "assets/images/Faith-2000x1340-c-center.jpg";
import backgroundRole from "assets/images/Faith-2000x1340-c-center-v2.jpg";
import { RoleSignupForms } from "components/Signup";
import { Spinner } from "components/Loader";

/**
 * Login
 */
const Signup = () => {
  const [searchParams] = useSearchParams();
  const roleSlug = searchParams.get("role");
  const intl = useIntl();
  const [signupCompleted, setSignupCompleted] = useState(false);

  const { data: role, loading } = useMissionRole({
    id: roleSlug,
    isPublicRole: true,
    skip: !roleSlug,
  });

  const isTalentSimple = isTalentSimpleBrand();
  const isRoleApplication = role?.state === MISSION_ROLE_STATES.published;

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Signup.Title" })}</title>
      </Helmet>
      <LoginContainer
        banner={bannerStyle(roleSlug, isTalentSimple)}
        isRoleApplication={isRoleApplication}
        signupCompleted={signupCompleted}
        roleData={role}
      >
        {loading ? (
          <Spinner />
        ) : isTalentSimple ? (
          <RoleSignupForms role={isRoleApplication ? role : null} onSignupCompleted={setSignupCompleted} />
        ) : (
          <SignupForms onSignupCompleted={setSignupCompleted} />
        )}
      </LoginContainer>
    </>
  );
};

const bannerStyle = (isRoleApplication, isTalentSimple) => ({
  title: "Gain access to exclusive opportunities and a network of top professionals.",
  ...(!isTalentSimple && { label: "Faith Adekogbe", description: "Frontend Developer" }),
  cover: isRoleApplication ? `url(${backgroundRole})` : `url(${backgroundNormal})`,
});

export default Signup;
